import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoCompareSelector from 'eco-design/sections/eco-compare-selector';
import { EcoCompareSelectorItemType } from 'eco-design/sections/eco-compare-selector/type';
import { useProductStore } from '../../../../ProductProvider';
import { useEffect, useState } from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { ItfBtn, ItfData } from '../C/type';
import { useSpec } from './useSpec';
import EcoLink from 'eco-design/base/eco-link';
import { generalKey_na } from '../../../../config/pageConfig';
import Dialog from 'elem/compPage/rapid-mag-power-bank/pages/product/componentsNA/C/Dialog';
import { colorMapping } from 'elem/compPage/rapid-mag-power-bank/pages/product/componentsNA/C/data';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';

const M: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('theProduct.M');
    const { productInfo } = useProductStore();
    const [items, setItems] = useState([] as EcoCompareSelectorItemType[]);
    const [multiId, setMultiId] = useState(0);

    const subs = useSpec(generalKey_na);

    const generateOptions = (): any[] => {
        const options = [] as { value: string; label: string }[];
        productInfo?.forEach((i: ItfData) => {
            const exited = options.find((j: { value: string; label: string }) => j.value === i.productTitle);
            if (!exited && generalKey_na.includes(i.spuKey || '')) {
                options.push({ label: i.productTitle, value: i.productTitle });
            }
        });
        return options;
    };

    const curStage = useScheduledContent({
        '2025/01/01 16:00:00 GMT+8': 1,
        '2025/11/13 16:00:00 GMT+8': 2,
        '2025/11/20 16:00:00 GMT+8': 3,
        '2025/11/24 16:00:00 GMT+8': 4,
        '2025/12/05 16:00:00 GMT+8': 5,
    });

    const generateItems = (options: any[]): EcoCompareSelectorItemType[] => {
        const arr = [] as EcoCompareSelectorItemType[];
        productInfo
            ?.sort((a: any, b: any) => generalKey_na.indexOf(a?.spuKey || '') - generalKey_na.indexOf(b?.spuKey || ''))
            ?.forEach((i: ItfData) => {
                const isNotify = i.inventoryQuantity <= 0 && i.inventoryPolicy === 'deny';
                const btnBuy: ItfBtn | undefined = i.btns.find((j) => j.type === 'buy');
                const btnMore: ItfBtn | undefined = i.btns.find((j) => j.type === 'learn');
                const target: EcoCompareSelectorItemType | undefined = arr.find((j) => j.productId === i.productId);
                const isNotOnline = typeof curStage === 'number' && curStage < i.allowLearnStage;
                if (target) {
                    const btns: any[] = [
                        isNotify
                            ? { text: t('btn_nofity'), type: 'filled', className: 'btn-notify', onClick: () => setMultiId(i.multiId) }
                            : { href: btnBuy?.link || '', text: t('btn_buy'), type: 'filled' },
                    ];
                    if (!isNotOnline) {
                        btns.push({ href: btnMore?.link || '', text: t('btn_more'), type: 'text', icon: true });
                    }
                    target?.colors?.push({
                        color: colorMapping[i.color],
                        pc: i.variantImg,
                        btns,
                    });
                } else {
                    if (generalKey_na.includes(i.spuKey)) {
                        const btns: any[] = [
                            isNotify
                                ? { text: t('btn_nofity'), type: 'filled', className: 'btn-notify', onClick: () => setMultiId(i.multiId) }
                                : { href: btnBuy?.link, text: t('btn_buy'), type: 'filled' },
                        ];
                        if (!isNotOnline) {
                            btns.push({ href: btnMore?.link || '', text: t('btn_more'), type: 'text', icon: true });
                        }
                        const obj = {
                            productId: i.productId,
                            items: options,
                            label: i.tag,
                            title: i.productTitle,
                            colors: [
                                {
                                    color: colorMapping[i.color],
                                    pc: i.variantImg,
                                    btns,
                                },
                            ],
                        } as EcoCompareSelectorItemType;
                        arr.push(obj);
                    }
                }
            });
        return arr;
    };

    const generateSpecs = (arr: EcoCompareSelectorItemType[]): void => {
        arr?.map((i: EcoCompareSelectorItemType, k: number) => {
            i.subs = subs[k];
        });
    };

    useEffect(() => {
        const options: any[] = generateOptions();
        const arr: EcoCompareSelectorItemType[] = generateItems(options);
        generateSpecs(arr);
        setItems(arr);
    }, [productInfo, subs]);

    return (
        <div
            id="CompareSelector"
            className={`rapid-mag-M ${css.section} GtmModuleData-section`}
            data-section-id={`rapid-mag-M`}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
                <EcoLink
                    className="GtmModuleData-btn-href desc"
                    href={`https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag`}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: 'EcoFlow Rapid Mag',
                        position: `EcoFlow Rapid Pro_${t('desc')}`,
                        __btn_id1: `rapid-mag-M`,
                        __btn_id2: `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag`,
                        __btn_type: 'href',
                    }}
                >
                    <span> {t('desc')}</span>
                    <EcoIconArrow />
                </EcoLink>
            </div>
            <EcoCompareSelector items={items} />
            <Dialog open={Boolean(multiId)} multiId={multiId} onClose={() => setMultiId(0)} />
        </div>
    );
};

export default M;
